import AppConfig from "servicestack/config.model.es6";
import { serializeQueryString } from "webutils/services/util";
export const IS_TEST = (ENV_TAGS || []).indexOf("Test") >= 0;
export const IS_SHOWROOM = (ENV_TAGS || []).indexOf("Showroom") >= 0; 

//export const IS_TEST = true;
export default class OneCoastAppConfig extends AppConfig {
  constructor() {
    super();
  }

  resolveServiceUrl(route) {
    if (!IS_TEST && !IS_SHOWROOM) {
    if (/RunReport|RunTM|RepScoreCard|ProductExport|EmailCart|EmailOrder|SalesOrderPrint/.test(route)) {
      let url = `https://oc032-crm-reporting.ws.emuncloud.com/service/${route}`;
      url += route.indexOf("?") > 0 ? "&" : "?";
      url += serializeQueryString(
        this.$session && this.$session.id
          ? {
              "ss-pid": this.$session.id,
              "ss-opt": "perm",
            }
          : {}
      );
      return url;
    }
  }

    return `${this.serviceUrl}${route}`;
  }
}
